import React from "react";
import "./style/loadingSpinner.scss";
import { ClipLoader } from "react-spinners";
import { useAppConfig } from "../../../hooks/useAppConfig";
import { useStrings } from "../../../hooks/useStrings";

const LoadingSpinner: React.FC<{
  btnColor?: string;
  fullScreen?: boolean;
  overlay?: boolean;
  messageRequired?: boolean;
  style?: React.CSSProperties;
}> = ({ fullScreen = true, overlay = false, messageRequired = false, style = {} }) => {
  const { themeColors } = useAppConfig();
  const S = useStrings();

  const content = (
    <div className="loading-overlay">
      <div className="loading-content">
        <ClipLoader size={50} color={themeColors.btnColor} />
        {messageRequired && <p className="mt-3">{S.COMMON.LOADING}</p>}
      </div>
    </div>
  );

  if (overlay) {
    return <div className="loader">{content}</div>;
  }

  return fullScreen ? (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ ...style, minHeight: "88vh" }}
    >
      {content}
    </div>
  ) : (
    content
  );
};

export default LoadingSpinner;
